import AutocompleteMuiCustom from '../../../../components/common/AutocompleteMuiCustom';
import TableHeaderHtmlCustom from '../../../../components/common/customTable/TableHeaderHtmlCustom';
import { TableCompHead } from '../../../../components/ui';
import { useQuery } from '../../../../hooks/UseQuery';

interface IProps {
  moduleData: any;
  isView: boolean;
}
const style1 = {
  backgroundColor: '#4F81BD',
  color: '#fff',
};

const THead = ({ moduleData, isView }: IProps) => {
  const annual_date: any = useQuery('annual_date');

  return (
    <thead>
      <TableCompHead
        colSpan={27}
        rowSpan={1}
        labels={[]}
        values={[]}
        heading={`Annaual Leaves FOR THE year - ${annual_date}`}
      />
      <tr style={style1}>
        <th>sno.</th>
        <th style={{ minWidth: '200px' }}>Name</th>
        <th style={{ minWidth: '150px' }}>DOJ</th>
        {[
          ` TILL DEC-${+annual_date?.slice(2) - 1} EL`,
          ``,
          `CL TILL Apr-${annual_date?.slice(2) - 1}`,
          `JAN-${annual_date}`,
          `FEB-${annual_date}`,
          `MARCH-${annual_date}`,
          `APRIL-${annual_date}`,
          `MAY-${annual_date}`,
          `JUNE-${annual_date}`,
          `JULY-${annual_date}`,
          `AUG-${annual_date}`,
          `SEPT-${annual_date}`,
          `OCT-${annual_date}`,
          `NOV-${annual_date}`,
          `DEC-${annual_date}`,
          'TOTAL',
          'BAL',
        ].map((item, index) => (
          <th style={{ minWidth: '80px' }}>{item}</th>
        ))}
        <td style={{ minWidth: '200px' }}>Remarks</td>
      </tr>
    </thead>
  );
};

export default THead;
